import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

import {
  SAVE_RIDER,
  RIDER_SAVING,
  REQUEST_RIDER,
  RECEIVE_RIDER,
  CREATE_RIDER,
  EDIT_RIDER,
  SHARE_RIDER,
  REMOVE_RIDER_SHARE,
  REQUEST_RIDER_EXPORT,
  RECEIVE_RIDER_EXPORT,
  DELETE_RIDER
} from '../actions/rider'

import {
  ADD_RIDER_CONTACT,
  REMOVE_RIDER_CONTACT,
  CREATE_RIDER_CONTACT,
  EDIT_RIDER_CONTACT,
  DELETE_RIDER_CONTACT
} from '../actions/rider-contact'

import {
  ADD_RIDER_MEMBER,
  REMOVE_RIDER_MEMBER,
  CREATE_RIDER_MEMBER,
  EDIT_RIDER_MEMBER,
  MOVE_RIDER_MEMBER,
  DELETE_RIDER_MEMBER
} from '../actions/rider-member'

import {
  ADD_RIDER_COLUMN,
  REMOVE_RIDER_COLUMN,
  CREATE_RIDER_COLUMN,
  MOVE_RIDER_COLUMN,
  DELETE_RIDER_COLUMN
} from '../actions/rider-column'

import {
  ADD_RIDER_ITEM,
  REMOVE_RIDER_ITEM,
  CREATE_RIDER_ITEM,
  CREATE_RIDER_ITEMS,
  CLONE_RIDER_ITEM,
  EDIT_RIDER_ITEM,
  MOVE_RIDER_ITEM,
  DELETE_RIDER_ITEM
} from '../actions/rider-item'

import {
  CREATE_RIDER_STAGEPLAN,
  EDIT_RIDER_STAGEPLAN,
  // VIEW_RIDER_STAGEPLAN,
  DELETE_RIDER_STAGEPLAN
} from '../actions/rider-stageplan'

import {
  ADD_RIDER_STAGEPLAN_ITEM,
  REMOVE_RIDER_STAGEPLAN_ITEM,
  CREATE_RIDER_STAGEPLAN_ITEM,
  EDIT_RIDER_STAGEPLAN_ITEM,
  DELETE_RIDER_STAGEPLAN_ITEM
} from '../actions/rider-stageplan-item'

const getAvailableItems = (items, members) => {
  const availableItems = [...items] // duplicate in order not to mutate data

  members.forEach((member, index) => {
    member.items.forEach((memberItem, index) => {
      const itemIndex = availableItems.map(item => item.id).indexOf(memberItem.id)

      if (itemIndex !== -1) availableItems.splice(itemIndex, 1)
    })
  })

  return availableItems
}

const mapChildrenToRow = (item, columns) => {
  let row = []

  if (columns && columns.length > 0) {
    columns.forEach(column => {
      if (column.type === 'instrument') {
        row = update(row, {$push: [item]})
      } else {
        const { children } = item

        const childIndex = column.type === 'custom'
        ? children.map(equipment => equipment.params && equipment.params.columnId).indexOf(column.id)
        : children.map(equipment => equipment.type.slug).indexOf(column.type)

        if (childIndex !== -1) {
          row = update(row, {$push: [children[childIndex]]})
        } else {
          row = update(row, {
            $push: [{
              class: 'equipment',
              type: {
                title: column.title,
                slug: column.type
              },
              parent: item.id,
              params: {
                columnId: column.id
              }
            }]
          })
        }
      }
    })
  }

  return row
}

const mapChildrenToRows = (items, columns) => {
  items.forEach((item, index) => {
    if (item.class === 'instrument') {
      const row = mapChildrenToRow(item, columns)

      items = update(items, {
        [index]: {
          row: {$set: row}
        }
      })
    } else
    if (item.class === 'instrument-group') {
      const { children } = item

      children.forEach((child, childIndex) => {
        if (child.class === 'instrument') {
          const row = mapChildrenToRow(child, columns)

          items = update(items, {
            [index]: {
              children: {
                [childIndex]: {
                  row: {$set: row}
                }
              }
            }
          })
        }
      })
    }
  })

  return items
}

const mapInstrumentsToMonitor = (instruments, monitor) => {
  let faders = []

  instruments.forEach(instrument => {
    if (instrument.class.includes('instrument')) {
      const { children } = monitor
      const childIndex = children.map(fader => fader.relation).indexOf(instrument.id)

      if (childIndex !== -1) {
        faders = update(faders, {$push: [children[childIndex]]})
      } else {
        faders = update(faders, {
          $push: [{
            class: 'fader',
            // type: {
            //   title: column.title,
            //   slug: column.type
            // },
            value: 5,
            parent: monitor.id,
            relation: instrument.id
          }]
        })
      }
    }
  })

  return faders
}

const mapInstrumentsToMonitors = (instruments, monitors) => {
  monitors.forEach((monitor, index) => {
    if (monitor.class === 'monitor') {
      const faders = mapInstrumentsToMonitor(instruments, monitor)

      monitors = update(monitors, {
        [index]: {
          faders: {$set: faders}
        }
      })
    } else
    if (monitor.class === 'monitor-group') {
      const { children } = monitor

      children.forEach((child, childIndex) => {
        if (child.class === 'monitor') {
          const faders = mapInstrumentsToMonitor(instruments, child)

          monitors = update(monitors, {
            [index]: {
              children: {
                [childIndex]: {
                  faders: {$set: faders}
                }
              }
            }
          })
        }
      })
    }
  })

  return monitors
}

const mapItemsToGroups = (items) => {
  let itemGroups = []

  items.forEach(item => {
    if (item.class === 'instrument-group') {
      itemGroups = update(itemGroups, {$push: [item]})
    }
  })

  return itemGroups
}

const saveRider = (state) => update(state, {saving: {$set: false}})

// const errorHandler = (action_payload) => {
//   if (action_payload instanceof Error) {
//     const { status, data } = action_payload.response
//     const { message } = data
//
//     return {
//       error: {
//         status,
//         message
//       }
//     }
//   }
// }

const errorHandler = (action_payload) => {
  const { data } = action_payload

  if (data.status === 'error') {
    return {
      error: {
        code: action_payload.status,
        message: data.message
      }
    }
  }
}

export default handleActions({
  [SAVE_RIDER]: (state, action) => {
    return update(state, {
      saving: {$set: true},
      // error: {$set: false}
    })
  },
  [RIDER_SAVING]: (state, action) => {
    const saving = action.payload

    // if (saving && saving.type === 'error') {
    //   state = update(state, {
    //     error: {$set: true}
    //   })
    // }

    return update(state, {saving: {$set: false}})
  },
  [REQUEST_RIDER]: (state, action) => ({isFetching: true}),
  [RECEIVE_RIDER]: (state, action) => {
    const error = errorHandler(action.payload)
    if (error) return error

    const { rider } = action.payload.data

    return update(rider, {
      availableItems: {$set: getAvailableItems(rider.input, rider.members)},
      itemGroups: {$set: mapItemsToGroups(rider.input)},
      input: {$set: mapChildrenToRows(rider.input, rider.columns)},
      output: {$set: mapInstrumentsToMonitors(rider.input, rider.output)},
      stageplans: {$set: rider.stageplans}
    })
  },
  [CREATE_RIDER]: (state, action) => {
    state = update(state, {
      $merge: {createdRiderId: action.payload.data.id}
    })

    return saveRider(state)
  },
  [EDIT_RIDER]: (state, action) => {
    let { rider } = action.payload.data

    state = update(rider, {
      availableItems: {$set: getAvailableItems(rider.input, rider.members)},
      itemGroups: {$set: mapItemsToGroups(rider.input)},
      input: {$set: mapChildrenToRows(rider.input, rider.columns)},
      output: {$set: mapInstrumentsToMonitors(rider.input, rider.output)},
      stageplans: {$set: rider.stageplans}
    })

    return saveRider(state)
  },
  [SHARE_RIDER]: (state, action) => {
    state = update(state, {
      shares: {$set: action.payload.data.shares}
    })

    return saveRider(state)
  },
  [REMOVE_RIDER_SHARE]: (state, action) => {
    state = update(state, {
      shares: {$set: action.payload.data.shares}
    })

    return saveRider(state)
  },
  [REQUEST_RIDER_EXPORT]: (state, action) => {
    return state = update(state, {
      // editable: {$set: false},
      isExporting: {$set: true}
    })
  },
  [RECEIVE_RIDER_EXPORT]: (state, action) => {
    return state = update(state, {
      editable: {$set: true},
      isExporting: {$set: false}
    })
  },
  [DELETE_RIDER]: (state, action) => {
    if (action.payload instanceof Error || action.payload.data.status !== 'success') {
      // TODO
    }

    state = update(state, {
      deletedRiderId: {$set: action.payload.data.id}
    })

    return saveRider(state)
  },
  [ADD_RIDER_CONTACT]: (state, action) => {
    const { contacts } = state
    const contactsLength = contacts.length

    if (contactsLength === 0 || contacts[contactsLength-1].id !== undefined) {
      const { contact } = action.payload

      state = update(state, {
        contacts: {$push: [contact]}
      })
    }

    return state
  },
  [REMOVE_RIDER_CONTACT]: (state, action) => {
    const { index } = action.payload

    if (index !== undefined) {
      state = update(state, {
        contacts: {$splice: [[index, 1]]}
      })
    }

    return state
  },
  [CREATE_RIDER_CONTACT]: (state, action) => {
    const contacts = action.payload.data.rider_contacts

    state = update(state, {
      contacts: {$set: contacts}
    })

    return saveRider(state)
  },
  [EDIT_RIDER_CONTACT]: (state, action) => {
    const contacts = action.payload.data.rider_contacts

    state = update(state, {
      contacts: {$set: contacts}
    })

    return saveRider(state)
  },
  [DELETE_RIDER_CONTACT]: (state, action) => {
    const contacts = action.payload.data.rider_contacts

    state = update(state, {
      contacts: {$set: contacts}
    })

    return saveRider(state)
  },
  [ADD_RIDER_MEMBER]: (state, action) => {
    const { members } = state
    const membersLength = members.length

    if (membersLength === 0 || members[membersLength-1].id !== undefined) {
      const { member } = action.payload

      state = update(state, {
        members: {$push: [member]}
      })
    }

    return state
  },
  [REMOVE_RIDER_MEMBER]: (state, action) => {
    const { index } = action.payload

    if (index !== undefined) {
      state = update(state, {
        members: {$splice: [[index, 1]]}
      })
    }

    return state
  },
  [CREATE_RIDER_MEMBER]: (state, action) => {
    const members = action.payload.data.rider_members

    state = update(state, {
      members: {$set: members}
    })

    return saveRider(state)
  },
  [EDIT_RIDER_MEMBER]: (state, action) => {
    const {
      rider_items,
      rider_input,
      rider_output,
      rider_members
    } = action.payload.data

    state = update(state, {
      availableItems: {$set: getAvailableItems(rider_input, rider_members)},
      items: {$set: rider_items},
      input: {$set: mapChildrenToRows(rider_input, state.columns)},
      output: {$set: mapInstrumentsToMonitors(rider_input, rider_output)},
      members: {$set: rider_members}
    })

    return saveRider(state)
  },
  [MOVE_RIDER_MEMBER]: (state, action) => {
    return saveRider(state)
  },
  [DELETE_RIDER_MEMBER]: (state, action) => {
    const members = action.payload.data.rider_members

    state = update(state, {
      members: {$set: members}
    })

    return saveRider(state)
  },
  [ADD_RIDER_COLUMN]: (state, action) => {
    const { column } = action.payload

    const columns = update(state.columns, {$push: [column]})

    state = update(state, {
      columns: {$set: columns},
      input: {$set: mapChildrenToRows(state.input, columns)}
    })

    return saveRider(state)
  },
  [REMOVE_RIDER_COLUMN]: (state, action) => {
    const { index } = action.payload

    const columns = update(state.columns, {$splice: [[index, 1]]})

    state = update(state, {
      columns: {$set: columns},
      input: {$set: mapChildrenToRows(state.input, columns)}
    })

    return saveRider(state)
  },
  [CREATE_RIDER_COLUMN]: (state, action) => {
    const { rider_columns } = action.payload.data

    state = update(state, {
      columns: {$set: rider_columns},
      input: {$set: mapChildrenToRows(state.input, rider_columns)}
    })

    return saveRider(state)
  },
  [MOVE_RIDER_COLUMN]: (state, action) => {
    const { columns } = action.payload.data

    state = update(state, {
      columns: {$set: columns},
      input: {$set: mapChildrenToRows(state.input, columns)}
    })

    return saveRider(state)
  },
  [DELETE_RIDER_COLUMN]: (state, action) => {
    const { columns } = action.payload.data

    state = update(state, {
      columns: {$set: columns},
      input: {$set: mapChildrenToRows(state.input, columns)}
    })

    return saveRider(state)
  },
  [ADD_RIDER_ITEM]: (state, action) => {
    const { item } = action.payload
    const { group, indexes } = item

    if (indexes[2] !== undefined) {
      return update(state, {
        [group]: {
          [indexes[0]]: {
            children: {
              [indexes[1]]: {
                children: {$splice: [[indexes[2], 0, item]]}
              }
            }
          }
        }
      })
    } else
    if (indexes[1] !== undefined) {
      return update(state, {
        [group]: {
          [indexes[0]]: {
            children: {$splice: [[indexes[1], 0, item]]}
          }
        }
      })
    } else
    if (indexes[0] !== undefined) {
      return update(state, {
        [group]: {$splice: [[indexes[0], 0, item]]}
      })
    }

    return state
  },
  [REMOVE_RIDER_ITEM]: (state, action) => {
    const { item } = action.payload
    const { group, indexes } = item

    if (indexes[2] !== undefined) {
      return update(state, {
        [group]: {
          [indexes[0]]: {
            children: {
              [indexes[1]]: {
                children: {$splice: [[indexes[2], 1]]}
              }
            }
          }
        }
      })
    } else
    if (indexes[1] !== undefined) {
      return update(state, {
        [group]: {
          [indexes[0]]: {
            children: {$splice: [[indexes[1], 1]]}
          }
        }
      })
    } else
    if (indexes[0] !== undefined) {
      return update(state, {
        [group]: {$splice: [[indexes[0], 1]]}
      })
    }

    return state
  },
  [CREATE_RIDER_ITEM]: (state, action) => {
    const {
      item,
      rider_items,
      rider_input,
      rider_output,
      rider_members,
      rider_tech_requirements,
      rider_non_tech_requirements,
      rider_hospitality
    } = action.payload.data

    let createChildren = []
    if (item.params && item.params.createChildren && item.params.createChildren.length > 0) {
      createChildren = item.params.createChildren

      createChildren.forEach((value, index) => {
        createChildren = update(createChildren, {
          [index]: {
            group: {$set: item.group},
            class: {$set: "instrument"},
            position: {$set: index+1},
            parent: {$set: item.id}
          }
        })
      })
    }

    state = update(state, {
      createChildren: {$set: createChildren},
      items: {$set: rider_items},
      availableItems: {$set: getAvailableItems(rider_input, rider_members)},
      itemGroups: {$set: mapItemsToGroups(rider_input)},
      input: {$set: mapChildrenToRows(rider_input, state.columns)},
      output: {$set: mapInstrumentsToMonitors(rider_input, rider_output)},
      members: {$set: rider_members},
      tech_requirements: {$set: rider_tech_requirements},
      non_tech_requirements: {$set: rider_non_tech_requirements},
      hospitality: {$set: rider_hospitality}
    })

    return saveRider(state)
  },
  [CREATE_RIDER_ITEMS]: (state, action) => {
    const {
      rider_items,
      rider_input,
      rider_output,
      rider_members,
      rider_tech_requirements,
      rider_non_tech_requirements,
      rider_hospitality
    } = action.payload.data

    state = update(state, {
      items: {$set: rider_items},
      availableItems: {$set: getAvailableItems(rider_input, rider_members)},
      itemGroups: {$set: mapItemsToGroups(rider_input)},
      input: {$set: mapChildrenToRows(rider_input, state.columns)},
      output: {$set: mapInstrumentsToMonitors(rider_input, rider_output)},
      tech_requirements: {$set: rider_tech_requirements},
      non_tech_requirements: {$set: rider_non_tech_requirements},
      hospitality: {$set: rider_hospitality}
    })

    return saveRider(state)
  },
  [CLONE_RIDER_ITEM]: (state, action) => {
    const {
      rider_items,
      rider_input,
      rider_output,
      rider_members,
      rider_tech_requirements,
      rider_non_tech_requirements,
      rider_hospitality
    } = action.payload.data

    state = update(state, {
      items: {$set: rider_items},
      availableItems: {$set: getAvailableItems(rider_input, rider_members)},
      itemGroups: {$set: mapItemsToGroups(rider_input)},
      input: {$set: mapChildrenToRows(rider_input, state.columns)},
      output: {$set: mapInstrumentsToMonitors(rider_input, rider_output)},
      tech_requirements: {$set: rider_tech_requirements},
      non_tech_requirements: {$set: rider_non_tech_requirements},
      hospitality: {$set: rider_hospitality}
    })

    return saveRider(state)
  },
  [EDIT_RIDER_ITEM]: (state, action) => {
    const {
      rider_items,
      rider_input,
      rider_output,
      rider_members,
      rider_tech_requirements,
      rider_non_tech_requirements,
      rider_hospitality
    } = action.payload.data

    state = update(state, {
      items: {$set: rider_items},
      availableItems: {$set: getAvailableItems(rider_input, rider_members)},
      itemGroups: {$set: mapItemsToGroups(rider_input)},
      input: {$set: mapChildrenToRows(rider_input, state.columns)},
      output: {$set: mapInstrumentsToMonitors(rider_input, rider_output)},
      members: {$set: rider_members},
      tech_requirements: {$set: rider_tech_requirements},
      non_tech_requirements: {$set: rider_non_tech_requirements},
      hospitality: {$set: rider_hospitality}
    })

    return saveRider(state)
  },
  [MOVE_RIDER_ITEM]: (state, action) => {
    const {
      rider_items,
      rider_input,
      rider_output,
      rider_members,
      rider_tech_requirements,
      rider_non_tech_requirements,
      rider_hospitality
    } = action.payload.data

    state = update(state, {
      items: {$set: rider_items},
      availableItems: {$set: getAvailableItems(rider_input, rider_members)},
      itemGroups: {$set: mapItemsToGroups(rider_input)},
      input: {$set: mapChildrenToRows(rider_input, state.columns)},
      output: {$set: mapInstrumentsToMonitors(rider_input, rider_output)},
      tech_requirements: {$set: rider_tech_requirements},
      non_tech_requirements: {$set: rider_non_tech_requirements},
      hospitality: {$set: rider_hospitality}
    })

    return saveRider(state)
  },
  [DELETE_RIDER_ITEM]: (state, action) => {
    const {
      rider_items,
      rider_input,
      rider_output,
      rider_members,
      rider_tech_requirements,
      rider_non_tech_requirements,
      rider_hospitality
    } = action.payload.data

    state = update(state, {
      items: {$set: rider_items},
      availableItems: {$set: getAvailableItems(rider_input, rider_members)},
      itemGroups: {$set: mapItemsToGroups(rider_input)},
      input: {$set: mapChildrenToRows(rider_input, state.columns)},
      output: {$set: mapInstrumentsToMonitors(rider_input, rider_output)},
      tech_requirements: {$set: rider_tech_requirements},
      non_tech_requirements: {$set: rider_non_tech_requirements},
      hospitality: {$set: rider_hospitality}
    })

    return saveRider(state)
  },
  [CREATE_RIDER_STAGEPLAN]: (state, action) => {
    const { rider_stageplans } = action.payload.data

    state = update(state, {
      stageplans: {$set: rider_stageplans}
    })

    return saveRider(state)
  },
  [EDIT_RIDER_STAGEPLAN]: (state, action) => {
    const { rider_stageplans } = action.payload.data

    state = update(state, {
      stageplans: {$set: rider_stageplans}
    })

    return saveRider(state)
  },
  // [VIEW_RIDER_STAGEPLAN]: (state, action) => {
  //   const stageplan = action.payload.data.stageplan
  //
  //   state = update(state, {
  //     stageplans: {
  //       [0]: {$set: stageplan}
  //     }
  //   })
  //
  //   return saveRider(state)
  // },
  [DELETE_RIDER_STAGEPLAN]: (state, action) => {
    return saveRider(state)
  },
  [ADD_RIDER_STAGEPLAN_ITEM]: (state, action) => {
    const { item } = action.payload
    let { items } = state.stageplans[0]

    items = update(items, {$push: [item]})

    return update(state, {
      stageplans: {
        [0]: {
          items: {$set: items},
        }
      }
    })
  },
  [REMOVE_RIDER_STAGEPLAN_ITEM]: (state, action) => {
    const { index } = action.payload

    return update(state, {
      stageplans: {
        [0]: {
          items: {$splice: [[index, 1]]},
        }
      }
    })
  },
  [CREATE_RIDER_STAGEPLAN_ITEM]: (state, action) => {
    const {
      rider_input,
      rider_output,
      rider_members,
      stageplan_items
    } = action.payload.data

    state = update(state, {
      input: {$set: mapChildrenToRows(rider_input, state.columns)},
      output: {$set: mapInstrumentsToMonitors(rider_input, rider_output)},
      members: {$set: rider_members},
      stageplans: {
        [0]: {
          items: {$set: stageplan_items},
        }
      }
    })

    return saveRider(state)
  },
  [EDIT_RIDER_STAGEPLAN_ITEM]: (state, action) => {
    const { data, index } = action.payload
    const stageplanItem = data.item
    // const {
    //   rider_input,
    //   rider_output,
    //   rider_members
    // } = action.payload.data

    state = update(state, {
      // input: {$set: mapChildrenToRows(rider_input, state.columns)},
      // output: {$set: mapInstrumentsToMonitors(rider_input, rider_output)},
      // members: {$set: rider_members},
      stageplans: {
        [0]: {
          items: {
            [index]: {$set: stageplanItem},
          }
        }
      }
    })

    return saveRider(state)
  },
  [DELETE_RIDER_STAGEPLAN_ITEM]: (state, action) => {
    // const { index } = action.payload
    const {
      rider_input,
      rider_output,
      rider_members,
      stageplan_items
    } = action.payload.data

    state = update(state, {
      input: {$set: mapChildrenToRows(rider_input, state.columns)},
      output: {$set: mapInstrumentsToMonitors(rider_input, rider_output)},
      members: {$set: rider_members},
      stageplans: {
        [0]: {
          items: {$set: stageplan_items}
        }
      }
    })

    return saveRider(state)
  }
}, {})



// WEBPACK FOOTER //
// ./src/reducers/rider.js